import React, { forwardRef } from 'react';
import FormGroup from '../../common/FormGroup';

export interface KeySearchTagFieldProps {
  label: string;
  error?: unknown;
  name: string;
  placeholder?: string;
  defaultValue?: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onSearch: () => void;
  searchDisabled?: boolean;
  searchButtonLabel: string;
  register?: any;
}

const KeySearchTagField = forwardRef<HTMLInputElement, KeySearchTagFieldProps>(
function KeySearchTagField(
  {
    label,
    error,
    name,
    placeholder,
    defaultValue,
    onChange,
    onSearch,
    searchDisabled,
    searchButtonLabel,
    register,
  },
  ref
) {
  const { ref: registerRef, ...registerProps } =
    register && name != null ? register(name) : { ref: undefined };

  const setInputRef = (element: HTMLInputElement | null) => {
    if (typeof ref === 'function') {
      ref(element);
    } else if (ref) {
      ref.current = element;
    }
    if (typeof registerRef === 'function') {
      registerRef(element);
    }
  };

  return (
    <FormGroup error={error}>
      <input
        ref={setInputRef}
        {...registerProps}
        type="text"
        aria-label={label}
        name={name}
        placeholder={placeholder}
        className="form-control"
        defaultValue={defaultValue}
        onChange={onChange}
        data-lpignore="true"
        autoComplete="off"
      />
      <button
        type="button"
        onClick={onSearch}
        className="btn btn-primary mt-2"
        disabled={searchDisabled}
      >
        {searchButtonLabel}
      </button>
    </FormGroup>
  );
});

export default KeySearchTagField;
